import React from "react"
import ValueCard from "./value-card"
import ValueImageCard from "./value-image-card"

import OurValues1 from "../../images/careers/OurValues1.png"
import OurValues2 from "../../images/careers/OurValues2.png"
import OurValues1Mobile from "../../images/careers/OurValues1-mobile.png"
import OurValues3Mobile from "../../images/careers/OurValues3-mobile.png"

const CultureValuesSection = () => {
  return (
    <section className="our-values-container container p-5">
      <div className="values-grid">
        <ValueCard
          title="Engaging our people"
          text="People are at the heart of what we do, supported by trust and respect to reach their full potential."
          background="#DEF8FF"
          className="engaging"
        />
        <ValueCard
          title="Bringing Passion & Hustle into Everything We Do"
          text="We’re driven by passion to help people become their best selves, knowing it takes heart and hustle to get there."
          background="linear-gradient(96.23deg, #DEF8FF 15.18%, #C9D1FB 117.44%)"
          className="bringing"
        />
        <ValueImageCard
          className="is-hidden-touch"
          image={OurValues1}
          alt="Team"
        />

        <ValueImageCard
          className="is-hidden-desktop our-values-1-mobile"
          image={OurValues1Mobile}
          alt="Team"
        />
        <ValueImageCard
          image={OurValues2}
          className="our-values-2"
          alt="Team wide"
          wide
        />

        <ValueCard
          title="Having Fun"
          text="We’re passionate about our mission, committed to each other, and believe in working hard while having fun."
          background="linear-gradient(108.63deg, #DEF8FF -117.37%, #C9D1FB 144.69%)"
          className="having-fun"
        />
        <ValueCard
          title="Innovating"
          text="We create game-changing solutions by dreaming big, moving fast, taking risks, and learning every step of the way."
          background="#DEF8FF"
          className="innovating"
        />
        <ValueCard
          title="Building Real Value for Customers"
          text="Our mission is simple: drive meaningful value and ROI for people, customers, and colleagues - success we celebrate collectively."
          background="linear-gradient(96.23deg, #DEF8FF 15.18%, #C9D1FB 117.44%)"
          className="building"
        />
        <ValueCard
          title="Keeping It Real"
          text="We believe people and ideas thrive in openness and transparency, building trust through honesty and accountability."
          background="linear-gradient(108.63deg, #DEF8FF -117.37%, #C9D1FB 144.69%)"
          className="keeping"
        />
        <ValueImageCard
          image={OurValues3Mobile}
          className="our-values-3 is-hidden-desktop is-hidden-tablet"
        />
      </div>
    </section>
  )
}

export default CultureValuesSection
